export enum UserType {
    User = 1, ServiceCenter, Admin
}

export enum UserImageType {
    Profile = 1, BusinessCover
}